
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tours",
      function () {
        return require("private-next-pages/tours/index.tsx");
      }
    ]);
  